import { render, staticRenderFns } from "./BudgetCostGroupDetailsAllocations.vue?vue&type=template&id=2f0296da&scoped=true&"
import script from "./BudgetCostGroupDetailsAllocations.vue?vue&type=script&lang=js&"
export * from "./BudgetCostGroupDetailsAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0296da",
  null
  
)

export default component.exports